module.exports = __webpack_public_path__ + "img/folders.721fb0fd.svg";